import { type CSSProperties, forwardRef } from "react"

type LoadingIndicatorProps = {
  blinkInterval?: number
  style?: CSSProperties
} & (
  | { width?: number; className?: string }
  | { width?: number; className: string }
)

export const LoadingIndicator = forwardRef<
  SVGSVGElement,
  LoadingIndicatorProps
>(function LoadingIndicator(
  { className, width = 62, blinkInterval = 1500, style },
  ref
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={width ? (62 / 84) * width : undefined}
      className={className}
      viewBox="0 0 84 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M36.214 51.682V61.86H21.186c-5.584 0-10.118-4.535-10.118-10.118V24.319H0v-9.98h11.048V.085h11.405V14.34h13.761v9.979h-13.76v27.363h13.76Z"
        className="fill-white"
      />
      <path
        d="M45.342 61.86V51.661h38.015V61.86H45.342Z"
        className="fill-[#00A67E] animate-blink"
        style={{
          animationDuration: `${blinkInterval}ms`,
        }}
      />
    </svg>
  )
})
